// 输入、枚举和户籍地策略需要运算符。
export const needsStrategyOperator = (elType) => [1, 2, 6].includes(Number(elType));

const isBlank = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === "string" && value.trim() === "");

// 校验与提交共用取值，商品回显未完成时保留已有 ID。
export function getStrategyHits(row) {
  const elType = Number(row.elType);
  if (elType === 5) {
    const options = Array.isArray(row.elData) ? row.elData : [];
    return options.length ? options.map((item) => item.value) : row.hits;
  }
  if (elType === 1 && Array.isArray(row.hits)) {
    return row.hits
      .slice(0, row.operator === "between" ? 2 : 1)
      .map((value) => (typeof value === "string" ? value.trim() : value));
  }
  return row.hits;
}

// 返回首个错误的位置与文案，人工干预可不关联策略。
export function findStrategyError(rows, requireOne) {
  if (!Array.isArray(rows) || !rows.length) {
    return requireOne ? { index: -1, message: "请至少添加一条规则" } : null;
  }
  for (let index = 0; index < rows.length; index++) {
    const row = rows[index];
    const elType = Number(row.elType);
    const name = row.strategyName || row.strategyCode;
    const error = (message) => ({ index, message: `「${name}」${message}` });
    if (needsStrategyOperator(elType) && isBlank(row.operator)) {
      return error("还没选择运算符");
    }
    if (![1, 2, 5, 6].includes(elType)) continue;
    const hits = getStrategyHits(row);
    if (!Array.isArray(hits) || !hits.length || isBlank(hits[0])) {
      return error("还没填写命中取值");
    }
    if (elType === 1 && row.operator === "between") {
      if (isBlank(hits[1])) return error("的取值区间只填了一头");
      // valueType 编码未明确，只比较可转换为有限数值的区间。
      const start = Number(hits[0]);
      const end = Number(hits[1]);
      if (Number.isFinite(start) && Number.isFinite(end) && start > end) {
        return error("的起始值不能大于结束值");
      }
    }
    if (hits.some(isBlank)) return error("的命中取值不能为空");
  }
  return null;
}
